import { render, staticRenderFns } from "./LoanChannel.vue?vue&type=template&id=303c6b6e&scoped=true"
import script from "./LoanChannel.vue?vue&type=script&lang=js"
export * from "./LoanChannel.vue?vue&type=script&lang=js"
import style0 from "./LoanChannel.vue?vue&type=style&index=0&id=303c6b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303c6b6e",
  null
  
)

export default component.exports